import ApiReqJson from "../ApiReqJson";
import AppConfig from "../../../../AppConfig";

const urlClienteSol = AppConfig.urlApiBase + '/cliente_sol';


export default  {
  DataIni: async () => {
    const url = `${urlClienteSol}/`;
    return await ApiReqJson.requestGET(url);
  },
  SolFromToken: async tokensol => {
    const url = `${urlClienteSol}/soldocfromtoken?tokensol=${tokensol}`;
    return await ApiReqJson.requestGET(url);
  },
  addFile: async (tokensol, keys3, idfile) => {
    const url = `${urlClienteSol}/addfile`;
    const data = {
      tokensol,
      keys3,
      idfile
    };
    return await ApiReqJson.requestPOST(url, data);
  },
  
  S3: {
    getJpgUploadUrl: async (tokensol, idfile) => {
      const url = urlClienteSol + `/s3crear`;
      const data = {
        tokensol,
        tipoArchivo: idfile,
        formatoArchivo: "jpg"
      };
      return await ApiReqJson.requestPOST(url, data);
    },
    getPDFUploadUrl: async (tokensol, idfile) => {
      const url = urlClienteSol + `/s3crear`;
      const data = {
        tokensol,
        tipoArchivo: idfile,
        formatoArchivo: "pdf"
      };
      return await ApiReqJson.requestPOST(url, data);
    }
  },
  requestPUTFile: async (url, objectFile) => {
    return ApiReqJson.requestPUTFile(url, objectFile);
  }
};

